import { useEnvironment } from '@strac/react-client-environment'
import { useScript } from '@uidotdev/usehooks'
import { useEffect } from 'react'

export default function useRecaptcha(): string {
  const { REACT_APP_RECAPTCHA_SITE_KEY } = useEnvironment()

  // Unload after unmount
  useEffect(() => {
    const unload = () => {
      const nodeBadge: any = document.querySelector('.grecaptcha-badge')
      if (nodeBadge) {
        document.body.removeChild(nodeBadge.parentNode)
      }
      const scriptSelector =
        "script[src='https://www.google.com/recaptcha/api.js?render=" + REACT_APP_RECAPTCHA_SITE_KEY + "']"
      const script = document.querySelector(scriptSelector)
      if (script) {
        script.remove()
      }
    }
    return () => {
      unload()
    }
  }, [REACT_APP_RECAPTCHA_SITE_KEY])

  const baseUrl = 'https://www.google.com/recaptcha/api.js?render='
  const url = `${baseUrl || 'https://www.google.com/recaptcha/api.js?render='}${REACT_APP_RECAPTCHA_SITE_KEY}`
  return useScript(url, {
    removeOnUnmount: true
  })
}
